/*
 *
 * RodOption
 *
 */

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from '../../../../../types';
import Img from '../../../../../components/Img';
import RemoveRodImg from '../../../../../assets/images/ribbons/shelvesRibbon/options/removeRod.png';
import RodImg from '../../../../../assets/images/ribbons/shelvesRibbon/options/rod.png';
import { addRodsAction, removeRodsAction } from './actions';
import { useTranslation } from 'react-i18next';
import { makeSelectCanAddRods, makeSelectCanRemoveRods } from './selectors';

interface StateProps {
  canRemoveRods: boolean;
  canAddRods: boolean;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  canRemoveRods: makeSelectCanRemoveRods(),
  canAddRods: makeSelectCanAddRods(),
});

interface Props {
  afterAction: any;
}

function RodOption({ afterAction }: Props) {
  const dispatch = useDispatch();
  const { canRemoveRods, canAddRods } = useSelector(stateSelector);
  const { t } = useTranslation();

  if (canRemoveRods) {
    return (
      <button
        onClick={() => {
          dispatch(removeRodsAction());
          afterAction();
        }}
        className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
      >
        <Img src={RemoveRodImg} alt="remove rood" className="h-8 w-8" />
        <div className="ml-4">{t('Remove rod')}</div>
      </button>
    );
  } else if (canAddRods) {
    return (
      <button
        onClick={() => {
          dispatch(addRodsAction());
          afterAction();
        }}
        className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
      >
        <Img src={RodImg} alt="add rood" className="h-8 w-8" />
        <div className="ml-4">{t('Add rod')}</div>
      </button>
    );
  }
  return null;
}

export default RodOption;
